(() => {
  if (window.fpGameVolumeReady) return;
  window.fpGameVolumeReady = true;
  const roots = () => [...document.querySelectorAll('[data-game-volume]:not([data-volume-mode="cart"])')];
  let sequence = 0;
  const render = (root, count) => {
    const tier = Math.min(20, Math.max(0, (count - 1) * 5));
    const next = Math.min(20, tier + 5);
    const countText = count === 1 ? root.dataset.countOne : root.dataset.count.replace('__count__', count);
    root.querySelector('[data-volume-count]').textContent = countText + (tier ? ' · ' + root.dataset.current.replace('__percent__', tier) : '');
    root.querySelector('[data-volume-progress]').textContent = count === 0 ? root.dataset.zero : count === 1 ? root.dataset.one : count >= 5 ? root.dataset.max : root.dataset.next.replace('__percent__', next);
    root.querySelectorAll('[data-volume-threshold]').forEach(item => item.classList.toggle('is-reached', count >= Number(item.dataset.volumeThreshold)));
  };
  const update = async () => {
    const current = roots();
    if (!current.length) return;
    const request = ++sequence;
    try {
      const response = await fetch(current[0].dataset.cartUrl, {headers: {'Accept': 'application/json'}, credentials: 'same-origin', cache: 'no-store'});
      if (!response.ok) return;
      const cart = await response.json();
      if (request !== sequence || !Array.isArray(cart.items)) return;
      const eligible = new Set(current[0].dataset.eligibleIds.split(','));
      const count = cart.items.reduce((total, item) => total + (eligible.has(String(item.product_id)) ? item.quantity : 0), 0);
      roots().forEach(root => render(root, count));
    } catch (_) {}
  };
  const init = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.cartUpdate, update);
    window.addEventListener('pageshow', event => {if (event.persisted) update()});
    document.addEventListener('shopify:section:load', update);
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();
